import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/services';
import { environment } from 'environments/environment';
import { of, Subject } from 'rxjs';
import { catchError, map, startWith, takeUntil } from 'rxjs/operators';
import { GLOBALS } from '../../../../../config/globals';
import { BaseService } from '../../../../../_helpers/base/base.service';
import { WebsocketService } from '../../../../../services/websocket.service';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class TimelineComponent implements OnInit, OnDestroy {

    public timeline: any;
    public activities: any;

    public boardData;
    public board;

    public loaders = { ...GLOBALS.loaders }; // To display/hide loading spinner
    public animations = { ...GLOBALS.animations }; // To use centralized animations
    public pageActions = GLOBALS.pageActions; // To use same naming conventions for opening one form for multiple purposes

    public currentLang: string;

    public env = environment;

    // use getter setter to define the property
    @Input()
    set search(val: any) {
        this.loaders.box = true;
        this._gService.post('mp/board/message/search', { board: this.board, search: val }, 'nodejs')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(res => {
                this.timeline = res.messages;
                this.loaders.box = false;
            });
    }

    @Input()
    set subscribers(val: any) {
        this.activities = val;
    }

    @Input()
    set _board(val: any) {
        this.board = val;
        this.ngOnInit();
    }

    //
    @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef;

    //
    public files = [];
    public inProgress = false;


    private _unsubscribeAll: Subject<void> = new Subject<void>();

    constructor(
        private router: Router,
        private actRoute: ActivatedRoute,
        private _gService: BaseService,
        private _formBuilder: FormBuilder,
        private _translateService: TranslateService,
        private _authenticationService: AuthenticationService,
        private socket: WebsocketService) {
        this._translateService.onLangChange
            .pipe(startWith(''))
            .subscribe(() => {
                this.currentLang = this._translateService.currentLang;
            });
    }

    public post = this._formBuilder.group({
        message: this._formBuilder.control('', Validators.required),
        photo: this._formBuilder.control(''),
        board: this._formBuilder.control(''),
    });

    ngOnInit(): void {
        this.loaders.box = true;
        this._gService.post('mp/board/messages/get/all/' + this.board, {}, 'nodejs')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(res => {
                if (res.status === true) {
                    this.timeline = res.data;
                    this.loaders.box = false;
                }
            });
    }
    public AddPost(): void {
        this.post.value.board = this.board;
        this.loaders.box = true;
        this._gService.post('mp/board/message/create', this.post.value, 'nodejs')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(res => {
                if (res.status === true) {
                    this.post.reset();
                    this.files = [];
                    this.loaders.box = false;
                    this.ngOnInit();
                    this.socket.emit('postCreate', {
                        created_by: this._authenticationService.currentUserValue._id, updated_by: this._authenticationService.currentUserValue._id,
                        agency: this._authenticationService.currentUserValue.agency, board: this.board, created_name: this._authenticationService.currentUserValue.full_name,
                        model_id: res.messageId
                    });
                }
            });
    }

    public reloadData(event): void {
        if (event === true) {
            this.ngOnInit();
        }
    }

    private uploadFile(file): void {
        this.inProgress = true;
        file.inProgress = true;
        const data = {
            id: this.board,
            model: 'mp_board_messages'
        };

        this._gService.uploadImage('attachments/single-upload/' + data.model + '/' + data.id, {}, file.data, 'nodejs')
            .pipe(takeUntil(this._unsubscribeAll))
            .pipe(
                map(event => {
                    switch (event.type) {
                        case HttpEventType.UploadProgress:
                            file.progress = Math.round(event.loaded * 100 / event.total);
                            break;
                        case HttpEventType.Response:
                            return event;
                    }
                }),
                catchError((error: HttpErrorResponse) => {
                    file.inProgress = false;
                    return of(`${file.data.name} upload failed.`);
                }))
            .subscribe((event: any) => {
                if (typeof (event) === 'object') {
                    this.post.get('photo').setValue(event.body.file_name);
                    this._gService.succussMessage('Image Uploaded', 'success');
                    this.inProgress = false;
                }
            });
    }

    /**
     * 
     */
    public uploadFiles(): void {
        this.fileUpload.nativeElement.value = '';
        this.files.forEach(file => {
            this.uploadFile(file);
        });
    }
    public onClick(): void {
        const fileUpload = this.fileUpload.nativeElement;
        fileUpload.onchange = () => {
            this.files = [];
            for (let index = 0; index < fileUpload.files.length; index++) {
                const file = fileUpload.files[index];
                this.files.push({ data: file, inProgress: false, progress: 0 });
            }
            this.uploadFiles();
        };
        fileUpload.click();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
